import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { FC } from "react";

const GridPage4: FC = () => {
    return (
        <div className="w-full min-h-dvh snap-start bg-white pt-[161px] flex flex-col gap-[42px] md:gap-[35px] items-center md:justify-between">
            <div className="flex flex-col gap-6 w-full items-center px-6 md:px-0">
                <p className="font-satoshi font-bold text-[24px] md:text-[36px] leading-[28px] md:leading-[48px] w-full md:w-[350px] text-[#1C1B1B] text-center"><span className="font-satoshi italic font-normal">Curo</span> is proactive</p>
                <p className="font-satoshi font-normal text-base md:text-xl text-[#303030] w-full md:w-[350px] text-center">Divide into daily task, tracks progress, and nudges you to stay consistent.</p>
            </div>
            <div className=" min-h[305px] h-[305px] w-full md:h-[416px] xl:h-[555px] max-w-[800px] px-6 md:px-0 rounded-tl-[32px] rounded-tr-[32px] flex items-center justify-center">
                <DotLottieReact
                    src="/landingpage/Curo-Proactive.json"
                    loop
                    autoplay
                />
            </div>
        </div>
    );
};

export default GridPage4;